import { PageProps } from 'gatsby';
import * as React from 'react';
import { Box, Flex, Grid, Image, Link, Paragraph, Text } from 'theme-ui';
import GatsbyLink from '../components/gatsby-link';
// @ts-expect-error SVG imports not recognized and I don't want to create a separate decl file
import logo from '../images/logo.svg';
// @ts-expect-error SVG imports not recognized and I don't want to create a separate decl file
import instagramIcon from '../images/instagram-icon.svg';

// <Link to='/sezione/editoriali'>Editoriali</Link>
// <Link to='/archivio'>Archivio numeri</Link>

const MainLayout: React.FC<PageProps> = ({ children }) => {
	return (
		<>
			<Box
				sx={{
					position: 'fixed',
					zIndex: -1,
					top: 0,
					right: 0,
					bottom: 0,
					left: 0,
					background: 'accentBackground',
				}}
			/>
			<Flex
				sx={{
					minHeight: '100vh',
					flexDirection: 'column',
					background: 'background',
				}}>
				<Box
					as='header'
					sx={{
						background: 'accentBackground',
						borderBottom: 'primary',
						pt: 8,
						px: 4,
					}}>
					<Flex sx={{ flexDirection: 'column', alignItems: 'center' }}>
						<Box>
							<GatsbyLink to='/'>
								<Image src={logo} width={180} alt='iThink.' />
							</GatsbyLink>
						</Box>
						<Flex
							as='nav'
							sx={{
								my: 4,
								rowGap: 0,
								columnGap: 4,
								flexWrap: 'wrap',
								alignItems: 'center',
								justifyContent: 'center',
							}}>
							<Text variant='button'>
								<GatsbyLink to='/'>Articoli</GatsbyLink>
							</Text>
							<Text variant='button'>
								<GatsbyLink to='/chi-siamo'>Chi siamo</GatsbyLink>
							</Text>
							<Text variant='button'>
								<GatsbyLink to='/contattaci'>Contattaci</GatsbyLink>
							</Text>
						</Flex>
					</Flex>
				</Box>

				<Box as='main' sx={{ width: '100%', mt: 6, px: 4 }}>
					<Grid
						gap={5}
						columns={[1, 2, 3]}
						sx={{ width: '100%', maxWidth: 1000, mx: 'auto' }}>
						{children}
					</Grid>
				</Box>

				<Box sx={{ flexGrow: 1 }} />

				<Box
					as='footer'
					sx={{
						background: 'accentBackground',
						borderTop: 'primary',
						mt: 8,
						py: 5,
						px: 4,
					}}>
					<Grid gap={5} columns={[1, 3]} sx={{ maxWidth: 1000, mx: 'auto' }}>
						<Box>
							<Paragraph variant='body'>
								iThink (*2014) è la rivista degli studenti del Liceo Classico e
								Scientifico dell’
								<Link
									href='https://www.istitutomassimo.it/'
									sx={{ color: '#0f5355' }}
									target='_blank'
									rel='noopener noreferrer'>
									Istituto Massimiliano Massimo
								</Link>
								.
							</Paragraph>
							<Paragraph variant='body' sx={{ color: 'white' }}>
								<Link
									href='https://www.instagram.com/imm.ithink/'
									sx={{ color: '#ff0069' }}
									target='_blank'
									rel='noopener noreferrer'>
									<Flex
										sx={{
											flexDirection: 'row',
											alignItems: 'center',
											justifyContent: 'flex-start',
											gap: 2,
										}}>
										<Image src={instagramIcon} width={18} alt='Instagram.' />
										<Text
											variant='button'
											sx={{ color: '#ff0069', fontWeight: 'subtitle' }}>
											@imm.ithink
										</Text>
									</Flex>
								</Link>
							</Paragraph>
						</Box>
						<Box>
							<Paragraph variant='body'>
								<Text variant='button'>
									<GatsbyLink to='/chi-siamo'>Chi siamo</GatsbyLink>
								</Text>
							</Paragraph>
							<Paragraph variant='body'>
								<Text variant='button'>
									<GatsbyLink to='/contattaci'>Contattaci</GatsbyLink>
								</Text>
							</Paragraph>
						</Box>
					</Grid>
				</Box>
			</Flex>
		</>
	);
};

export default MainLayout;
